export default "__VITE_ASSET__CL33rfOs__"